import base from '../dr-base'
import drCardLabel from './dr-card-label.vue'

const schema = {
  $Type: 'dr-card-label',
  name: 'Card label',
  group: 'Common widgets',
  icon: 'heading',
  ...base,
  properties: {
    ...base.properties,
    Text: {
      name: 'vuetifyWidgets.dr-card-label.text',
      type: 'string',
      component: 'dr-value-editor'
    },
    Title: {
      name: 'vuetifyWidgets.dr-card-label.title',
      type: 'string',
      component: 'dr-value-editor'
    }
  }
}

export default {
  schema,
  component: drCardLabel
}